import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import FilterTimeLine from '../line/filterTimeLine';
import Modal, {ModalContainer} from '../modal';
import AccountSettings from '../account/settings';


@withRouter
@inject('accountStore', 'lineStore', 'dictStore')
@observer
class UnderHeader extends Component {
  state = {
    showSettings: false,
    showBets: false
  };

  toggleAllLeague = () => {
    this.props.lineStore.line.toggleAllLeagueShow();
  };

  toggleSettings = () => {
    this.setState({ showSettings: !this.state.showSettings });
  };

  backToBets = () => {
    const lastAction = localStorage.getItem('lastAction');

    if (lastAction && Number(lastAction) === 1) {
      this.props.history.push('/line');
    } else {
      this.props.history.push('/live');
    }
  };

  render () {
    const { type } = this.props;
    const { goBack, goForward } = this.props.history;
    const { mode } = this.props.lineStore;
    const { showTableItemsAll } = this.props.lineStore.line;
    const { access } = this.props.accountStore;
    const { basketPosition } = this.props.accountStore.accountSettings;

    const content = {
      1: // for LINE / LIVE
        <div
          className="under-header"
          style={{
            display: 'inline-block',
            padding: '5px 10px 0 5px',
          }}
        >
          <a
            className="control-panel-item line-come-back white-btn"
            onClick={goBack}
          >
            <span className="control-panel-ico f-s-ico-arrow_left" />
            <span className="control-panel-text">Назад</span>
          </a>
          <a
            className="control-panel-item line-go-forward white-btn"
            onClick={goForward}
          >
            <span className="control-panel-text">Вперед</span>
            <span className="control-panel-ico f-s-ico-arrow_right_1" />
          </a>
          {mode === 'line' && <FilterTimeLine />}
          <div className={`control-panel-right ${basketPosition === 'left' ? 'on-edge' : ''}`}>
            <a
              className="control-panel-item white-btn line-toggle-all"
              onClick={this.toggleAllLeague}
            >
              <span className="control-panel-text">{showTableItemsAll ? 'Развернуть все' : 'Свернуть все'}</span>
            </a>
            {access ? (
              <a
                className="control-panel-item account-settings-show white-btn"
                onClick={this.toggleSettings}
              >
                <span className="control-panel-ico f-s-ico-settings" />
                <span className="control-panel-text">Настройки</span>
              </a>
            ) : null}
          </div>
          {this.state.showSettings && (
            <ModalContainer>
              <Modal
                styleModal={{ width: '600px' }}
                show={this.state.showSettings}
                onCloseModal={this.toggleSettings}
                title="Настройки аккаунта"
                footer={1}
                closeButton={1}
              >
                <AccountSettings/>
              </Modal>
            </ModalContainer>
          )}
        </div>,
      2: // for other pages
        <div
          className="control-panel under-header"
          style={{
            display: 'inline-block',
            padding: '5px 10px 0 5px',
          }}>
          <a
            className="control-panel-item line-come-back white-btn"
            onClick={goBack}
          >
            <span className="control-panel-ico f-s-ico-arrow_left" />
            <span className="control-panel-text">Назад</span>
          </a>
          <a
            className="control-panel-item line-go-forward white-btn"
            onClick={goForward}
          >
            <span className="control-panel-text">Вперед</span>
            <span className="control-panel-ico f-s-ico-arrow_right_1" />
          </a>
          <a
            className="control-panel-item back-to-bets white-btn"
            onClick={this.backToBets}
          >
            <span className="control-panel-text">Вернуться к ставкам</span>
          </a>
        </div>
    };

    return content[type];
  }
}

export default UnderHeader;


// WEBPACK FOOTER //
// ./src/components/underHeader/index.jsx